import { SharedModule } from "./../../app/shared.module";
import { LoginProvider } from "../../providers/login/login";
import { NgModule } from "@angular/core";

import { SwiperModule } from 'ngx-swiper-wrapper';
import { OverviewComponent } from "./overview.component";

@NgModule({
	declarations: [OverviewComponent],
	imports: [
        SwiperModule,
		SharedModule
	],
	exports: [OverviewComponent],
	providers: [
		LoginProvider
	]
})
export class OverviewModule { }
